import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import Spinner from '@atlaskit/spinner/spinner';

import { i18n } from '../changeHistoryMacroI18n.ts';

export const LoadingState = (): React.JSX.Element => {
	return (
		<Box padding="space.100" testId="change-history-loading">
			<Inline alignBlock="center" space="space.100">
				<Spinner size="small" label="" />
				<Text color="color.text.subtle">
					<FormattedMessage {...i18n.loading} />
				</Text>
			</Inline>
		</Box>
	);
};
